import { addBonusProvider } from '../game/bonuses';
import type { Game } from '../game/Game';
import { install as bonds } from './bonds';
import { install as bounties } from './bounties';
import { install as build } from './build';
import { install as economy } from './economy';
import { install as events } from './events';
import { havenBonus, install as haven } from './haven';
import { install as instances } from './instances';
import { install as journal } from './journal';
import { install as lifeskills } from './lifeskills';
import { install as mounts } from './mounts';
import { install as pets } from './pets';
import { install as quests } from './quests';
import { install as sailing } from './sailing';
import { install as settings } from './settings';
import { install as travel } from './travel';

/** Installs every gameplay feature module (panels, systems, handlers). Order does not matter. */
export function installFeatures(game: Game): void {
  for (const install of [quests, build, economy, bounties, journal, settings, travel, lifeskills, haven, bonds, events, sailing, instances, mounts, pets]) install(game);
  addBonusProvider((key) => havenBonus(game.account, key));
}
